import { type UpcomingMaintenancesByStatus, type WebData, webDataError, webDataFetching, webDataNotAsked, webDataSuccess } from '@cobliteam/api-lib';
import { type Draft, produce } from 'immer';
import type { Reducer } from 'redux';
import type { UpcomingMaintenancesAction } from './actions';
import { ActionTypes } from './actionTypes';

export interface UpcomingMaintenancesState {
  upcomingMaintenancesByStatusWebData: WebData<UpcomingMaintenancesByStatus>;
}

export const upcomingMaintenancesInitialState: UpcomingMaintenancesState = {
  upcomingMaintenancesByStatusWebData: webDataNotAsked(),
};

export const upcomingMaintenancesReducer: Reducer<UpcomingMaintenancesState, UpcomingMaintenancesAction> = produce(
  (draft: Draft<UpcomingMaintenancesState>, action: UpcomingMaintenancesAction) => {
    switch (action.type) {
      case ActionTypes.LOAD_UPCOMING_MAINTENANCES_REQUEST:
        draft.upcomingMaintenancesByStatusWebData = webDataFetching();
        break;

      case ActionTypes.LOAD_UPCOMING_MAINTENANCES_SUCCEEDED:
        draft.upcomingMaintenancesByStatusWebData = webDataSuccess(action.payload);
        break;

      case ActionTypes.LOAD_UPCOMING_MAINTENANCES_FAILED:
        draft.upcomingMaintenancesByStatusWebData = webDataError();
        break;
    }
  },
  upcomingMaintenancesInitialState
);
